module.exports = __webpack_public_path__ + "static/media/Nail-Fairy.db6d9a5c.png";